<div
  *ngIf="loading"
  class="loading-content"
  [@inOutAnimation]
  [class.fixed]="position === 'fixed'"
  [class.absolute]="position === 'absolute'"
>
  <ark-loader-inline color="dark" class="loader"></ark-loader-inline>
</div>
